import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4d2e7c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "companion-hotspots" }

import { computed } from 'vue';

import CompanionHotspot from '@/components/CompanionHotspot/CompanionHotspot.vue';
import { useGameState } from '@/services/composition'
import { Hotspot, useHotspots } from '@/services/stores/hotspots'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const state = useGameState()
const { hotspots } = useHotspots()

const isTuto = computed(() => {
   return state.value.matches('tuto.companion.contact') || state.value.matches('tuto.companion.plan') || state.value.matches('tuto.companion.teammate')
})

const currentHotspots = computed(() => {
  if (isTuto.value) {
    return []
  }
  const filtered = hotspots.filter(hotspot => hotspot.states.some(hState => state.value.matches(hState))) as Hotspot[]
  return filtered
})

const lastAdvisedHotspot = computed(() => {
  const advisedHotspots = state.value.context.advisedHotspots
  return advisedHotspots[advisedHotspots.length - 1]
})
/**
 * disable hotspots if last advised hotspot has not been clicked by the teammate yet
 */
const isLastAdvisedHotspotDone = computed(() => {
  const findIndex = currentHotspots.value.findIndex(hotspot => hotspot.id === lastAdvisedHotspot.value && !state.value.context.hotspots.includes(hotspot.id))
  return findIndex === -1
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentHotspots), (h) => {
      return (_openBlock(), _createBlock(CompanionHotspot, {
        key: h.id,
        hotspot: h,
        disabled: !_unref(isLastAdvisedHotspotDone)
      }, null, 8, ["hotspot", "disabled"]))
    }), 128))
  ]))
}
}

})